import React, { useState } from "react";
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { TextoAdvertencia } from "../../ComponentsCat/Mensajes/Mensajes";
import { Calendar } from 'primereact/calendar';
import { InputText } from "primereact/inputtext";
import { Service } from "../../../../service/Service";
import Environment from "../../../../Environment";
import { LICENCIAS_CLIENTE, CLIENTE } from "../../../../genericos/Uris";
import Spinner from "../../../../components/loader/Spinner";
import ErrorSistema from "../../../../components/error/ErrorSistema";

const Licencias = ({
    licenciaCliente, dialogLicencia, setDialogLicencia,
    setLicenciaCliente, idCliente, loading, setLoading, setProducts, notificacionCrearLicencia
}) => {
    const getRoute = Environment();
    const licenciaService = new Service();
    const [texto, setTexto] = useState("");
    const [estiloUsuario, setEstiloUsuario] = useState("");
    const [estiloMaquina, setEstiloMaquina] = useState("");
    const [estiloFechaInicio, setEstiloFechaInicio] = useState("");
    const [estiloFechaFin, setEstiloFechaFin] = useState("");


    const validateLicencia = async () => {
        setLoading(true);
        console.log("Creando licencia")

        // --> Validacion de campos
        if (licenciaCliente.maquinas === "") {
            setEstiloMaquina("p-invalid");
            setTexto("Campo invalido");
            setLoading(false);
            return;
        }
        if (licenciaCliente.usuarios === "") {
            setEstiloUsuario("p-invalid");
            setTexto("Campo invalido");
            setLoading(false);
            return;
        }
        if (licenciaCliente.fechaInicio === "") {
            setEstiloFechaInicio("p-invalid");
            setTexto("Campo invalido");
            setLoading(false);
            return;
        }
        if (licenciaCliente.fechaTermino === "") {
            setEstiloFechaFin("p-invalid");
            setTexto("Campo invalido");
            setLoading(false);
            return;
        }
        licenciaService.baseUrl = `${getRoute}/${LICENCIAS_CLIENTE}/${idCliente}`;
        try {
            await licenciaService.update(licenciaCliente);
            licenciaService.baseUrl = `${getRoute}/${CLIENTE}`;

            const data = await licenciaService.readAll();
            setProducts(data);
            hideLicenciaDialog();
            notificacionCrearLicencia();

        } catch (e) { console.log(e) }
    }

    const hideLicenciaDialog = () => {
        setLoading(false);
        setDialogLicencia(false);
    }
    const updateField = (data, field) => {
        setLicenciaCliente({
            ...licenciaCliente,
            [field]: data,
        });
    };
    const footer = () => {
        return (<>
            {loading ? (<></>) : (
                <>
                    <div className='flex justify-content-between flex-wrap'>
                        <Button label="Atras" icon="pi pi-times" iconPos="right" severity="success" onClick={hideLicenciaDialog} />
                        <Button label="Guardar" icon="pi pi-check" iconPos="right" severity="danger" onClick={validateLicencia} />
                    </div>
                </>
            )}
        </>)
    }
    licenciaCliente.fechaInicio = new Date(licenciaCliente.fechaInicio);
    licenciaCliente.fechaTermino = new Date(licenciaCliente.fechaTermino);
    return (
        <Dialog
            visible={dialogLicencia}
            onHide={hideLicenciaDialog}
            header="Modificar licencia" style={{ width: '650px' }} modal
            footer={footer}
        >
            {loading ? (<><Spinner /></>) : (<>
                <div className="grid">
                    <div className="col-12 mt-5 grid ">
                        <div className="field col-6">
                            <span className="p-float-label">
                                <InputText id="maquinas" keyfilter="int" value={licenciaCliente.maquinas || ''} onChange={(e) => { updateField(e.target.value, "maquinas"); setEstiloMaquina("") }} />
                                <label className="font-bold" htmlFor="maquinas">No Máquinas</label>
                            </span>
                            {estiloMaquina && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                        </div>
                        <div className="field col-6">
                            <span className="p-float-label">
                                <InputText id="usuarios" keyfilter="int" value={licenciaCliente.usuarios || ''} onChange={(e) => { updateField(e.target.value, "usuarios"); setEstiloUsuario("") }} />
                                <label className="font-bold" htmlFor="usuarios">No usuarios</label>
                            </span>
                            {estiloUsuario && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                        </div>
                    </div>
                    <div className="col-12 grid">
                        <div className="field col-6">
                            <span className="p-float-label">
                                <Calendar
                                    id="finicio"
                                    dateFormat="yy/mm/dd"
                                    value={licenciaCliente.fechaInicio || ""}
                                    onChange={(e) => { updateField(e.target.value, "fechaInicio"); setEstiloFechaInicio("") }}
                                    showTime
                                />
                                <label className="font-bold" htmlFor="finicio">Fecha Inicio</label>
                            </span>
                            {estiloFechaInicio && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                        </div>
                        <div className="field col-6">
                            <span className="p-float-label">
                                <Calendar
                                    id="time24"
                                    dateFormat="yy/mm/dd"
                                    value={licenciaCliente.fechaTermino || ""}
                                    onChange={(e) => { updateField(e.target.value, "fechaTermino"); setEstiloFechaFin("") }}
                                    showTime
                                />
                                <label className="font-bold" htmlFor="finicio">Fecha Termino</label>
                            </span>
                            {estiloFechaFin && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                        </div>
                    </div>
                    <div className="col-10">
                        <div className="field">
                            <span className="p-float-label">
                                <InputText id="uuid" className="col-12" disabled value={licenciaCliente.uuid || ""} onChange={(e) => { updateField(e.target.value, "uuid"); setEstiloMaquina("") }} />
                                <label className="font-bold" htmlFor="maquinas">Licencia</label>
                            </span>
                        </div>
                    </div>
                </div>
            </>)}
        </Dialog>
    )

}

export default React.memo(Licencias); 